import { useTranslation } from "react-i18next";
import { Button } from "barte-design-system";
import { CreditCardIcon } from "@phosphor-icons/react";

import { CardInfo } from "@shared/components";
import { formatDelay, formatPercentage } from "@shared/helpers";
import type { CardDebitCardProps } from "./card-debit-card.type";
import styles from "../../rate-plan-details.module.css";

export const CardDebitCard = ({
    isLoading,
    data,
    companyPlan,
    taxAggregateVersion,
    onEdit,
}: CardDebitCardProps) => {
    const { t } = useTranslation();

    const companyRate = companyPlan?.value;

    const markupRate =
        taxAggregateVersion === "2"
            ? (data?.value || 0) - (companyRate || 0)
            : data?.value;

    const totalRate =
        taxAggregateVersion === "2"
            ? data?.value
            : (companyRate || 0) + (data?.value || 0);

    const allItems = [
        {
            key: "redeemTime",
            label: t("payfac.pageRatePlanDetailsRedeemTime"),
            value: formatDelay(data?.delayForRedeem),
        },
        {
            key: "rateType",
            label: t("payfac.pageRatePlanDetailsRateType"),
            value:
                data?.rateType === "PERCENTAGE"
                    ? t("payfac.pageRatePlanDetailsPercentage")
                    : t("payfac.pageRatePlanDetailsFixed"),
        },
        {
            key: "rate",
            label: t("payfac.pageRatePlanDetailsMarkup"),
            value: formatPercentage(markupRate),
        },

        {
            key: "companyRate",
            label: t("payfac.pageRatePlanDetailsCompanyRate"),
            value: formatPercentage(companyRate),
        },

        {
            key: "totalRate",
            label: t("payfac.pageRatePlanDetailsTotalRate"),
            value: formatPercentage(totalRate),
        },
    ];

    return (
        <CardInfo
            title={
                <span className={styles["card-title"]}>
                    <CreditCardIcon className={styles.icon} />{" "}
                    {t("payfac.pageRatePlanDetailsDebitCard")}
                </span>
            }
            action={
                <Button size="sm" variant="outline" onClick={onEdit}>
                    {t("payfac.pageRatePlanDetailsEditButton")}
                </Button>
            }
            isLoading={isLoading}
            info={allItems}
        />
    );
};
